export default "__VITE_ASSET__fNgiTqVp__"